import { render, staticRenderFns } from "./ContactFormCard.vue?vue&type=template&id=0b355e9e&scoped=true"
import script from "./ContactFormCard.vue?vue&type=script&lang=js"
export * from "./ContactFormCard.vue?vue&type=script&lang=js"
import style0 from "./ContactFormCard.vue?vue&type=style&index=0&id=0b355e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b355e9e",
  null
  
)

export default component.exports